// extracted by mini-css-extract-plugin
module.exports = {"component":"QuantityInput_component__J5_Ll","number":"QuantityInput_number__5Cco_"};